import {useContext} from "react";
import {ThreadContext} from "../../../context/threadContext";
import UserAvatar from "../../common/UserAvatar";
import Username from "../../common/Username";

import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';

import { MediaPlayer, MediaProvider } from '@vidstack/react';
import { defaultLayoutIcons, DefaultVideoLayout } from '@vidstack/react/player/layouts/default';

const Videos = () => {
	const {
		thread, videos, fetchVideos
	} = useContext(ThreadContext);

	fetchVideos();

	if (thread) {
		return (
			<div className="border border-borderColor flex flex-wrap rounded-lg">
				<div
					className="w-full flex gap-x-2 bg-primary bg-opacity-85 p-2 flex-shrink-0 flex-grow-0 lg:block lg:w-[160px] lg:text-center">
					<a href={thread.User ? thread.User.view_url : '#'} title={thread.username}
					   className="block w-[48px] h-[48px] mb-2 lg:mx-auto lg:w-[96px] lg:h-[96px]">
						<UserAvatar user={thread.User}/>
					</a>

					<div>
						<p className="mb-2 overflow-hidden max-w-full">
							<Username user={thread.User}/>
						</p>

						{thread.User && (
							<p className="text-sm text-white">
								{thread.User.custom_title ? thread.User.custom_title : thread.User.user_title}
							</p>
						)}
					</div>
				</div>

				<div className="flex-1 p-4 min-w-0">
					<div className="flex flex-col h-full">
						{videos && videos.length > 0 && (
							<div className="video-list">
								{videos.map((video, index) => (
									<MediaPlayer
										key={index}
										title={video.filename} src={video.direct_url}
										className="w-full h-full"
										autoplay muted loop
									>
										<MediaProvider className="w-full h-full" />
										<DefaultVideoLayout icons={defaultLayoutIcons} />
									</MediaPlayer>
								))}
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default Videos;